document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  menuButton?.addEventListener('click', () => {
    menu.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', menu.classList.contains('is-open'));
  });
  const finder = document.querySelector('[data-tv-finder]');
  if (!finder) return;
  const normalise = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const records = new Map();
  const addPage = (root) => root.querySelectorAll('[data-tv-model-page]').forEach((node) => {
    try {
      JSON.parse(node.textContent).items.forEach((record) => {
        const key = `${normalise(record.brand)}|${normalise(record.model)}`;
        if (normalise(record.model)) records.set(key, record);
      });
    } catch (_) {}
  });
  addPage(document);
  const sectionId = finder.dataset.sectionId;
  const pageCount = Number(finder.dataset.pages || 1);
  const pageParam = finder.dataset.pageParam || 'page';
  const status = finder.querySelector('[data-finder-status]');
  const result = finder.querySelector('[data-finder-result]');
  const form = finder.querySelector('[data-metaobject-fit-form]');
  Promise.all(Array.from({ length: Math.max(0, pageCount - 1) }, async (_, index) => {
    const url = new URL(location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set(pageParam, index + 2);
    const response = await fetch(url);
    if (!response.ok) throw new Error('Could not load model page');
    addPage(new DOMParser().parseFromString(await response.text(), 'text/html'));
  })).then(() => {
    status.textContent = `${records.size} verified TV models ready to search.`;
  }).catch(() => {
    status.textContent = 'Some model records could not be loaded. Please try again or contact us.';
    status.classList.add('is-error');
  });
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const brand = normalise(form.elements.brand.value === 'Other' ? '' : form.elements.brand.value);
    const query = normalise(form.elements.model.value);
    const queryWithoutBrand = brand && query.startsWith(brand) ? query.slice(brand.length) : query;
    const match = Array.from(records.values()).find((record) => {
      const recordBrand = normalise(record.brand);
      const recordModel = normalise(record.model);
      return recordModel === query || recordModel === queryWithoutBrand || (brand && recordBrand === brand && recordModel === queryWithoutBrand);
    });
    result.hidden = false;
    if (!match) {
      result.innerHTML = '<h4>We could not verify that exact model.</h4><p>Check the rear-label model number and try again. If it is correct, our team can confirm the fit manually.</p><a class="button button--outline" href="/pages/contact-us">Ask us to check</a>';
      return;
    }
    const title = [match.productTitle, match.variantTitle].filter(Boolean).join(' — ');
    const size = match.screenSize ? `<p>Recorded screen size: ${match.screenSize} inch</p>` : '';
    result.innerHTML = `<span class="eyebrow">Verified match</span><h4>${match.brand} ${match.model}</h4>${size}<p>${title}</p><a class="button button--blue" href="${match.variantUrl}">View the correct protector</a>`;
  });
});
